/* eslint-disable no-unused-vars */
import * as S from './AssociatedCampaignsTab.styled';
import { useCallback, useContext, useEffect } from 'react';
import { ChooseAudienceManagementContext } from 'contexts';
import {
  Buttons,
  TableCell,
  ParagraphWithTooltip,
  CopyString,
  NotificationModal,
} from 'components';
// import { useSortableData } from 'utils';
import { useSortableData } from './useSortableData';
import { Pause, Start, Question } from 'assets/icons';
import { useSignal, useComputed } from '@preact/signals-react';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';

const icons = {
  0: Start,
  3: Pause,
  default: Question,
};

export const AssociatedCampaignsTab = () => {
  const {
    cust_aud_name,
    associated_apps,
    associated_campaigns,
    custom_audience_file_upload_el,
    campaigns,
  } = useContext(ChooseAudienceManagementContext);

  const [dissconnectAssosiatedCampaigns, dissconnectAssosiatedCampaignsResult] =
    saveCampaignServiceAPI.useDissconnectAssosiatedCampaignsMutation();

  const { items, requestSort, getClassNamesFor } = useSortableData(associated_campaigns ?? []);

  const notificationModalIsOpen$ = useSignal(false);
  const campaignIdToDelete$ = useSignal(false);

  useEffect(() => {
    if (dissconnectAssosiatedCampaignsResult.isSuccess) {
      notificationModalIsOpen$.value = false;
    }
  }, [dissconnectAssosiatedCampaignsResult.isSuccess]);

  const handleDisconnectAll = () => {
    if (notificationModalIsOpen$.value === 'disconnectAll') {
      notificationModalIsOpen$.value = false;
      return;
    }
    notificationModalIsOpen$.value = 'disconnectAll';
  };

  const handleDeselectCurrent = (cm_campaignid) => {
    if (notificationModalIsOpen$.value === 'disconnect') {
      notificationModalIsOpen$.value = false;
      return;
    }
    notificationModalIsOpen$.value = 'disconnect';
    campaignIdToDelete$.value = cm_campaignid;
  };

  const closeNotificationModal = useCallback(() => {
    notificationModalIsOpen$.value = false;
    campaignIdToDelete$.value = false;
  }, []);

  const confirmNotificationModal = useCallback((id) => {
    let campaignIds = [];

    if (id === 'disconnect') {
      associated_campaigns.forEach((campaign) => {
        if (campaign.cm_campaignid == campaignIdToDelete$.value) {
          campaignIds.push(campaign.cm_id);
        }
      });
    }
    if (id === 'disconnectAll') {
      associated_campaigns.forEach((campaign) => {
        campaignIds.push(campaign.cm_id);
      });
    }

    dissconnectAssosiatedCampaigns(campaignIds);
  }, []);

  const campaignToDeleteName = useComputed(() => {
    if (!campaignIdToDelete$.value) return '';
    return associated_campaigns.find(
      (campaign) => campaign.cm_campaignid == campaignIdToDelete$.value,
    )?.cm_name;
  });

  return (
    <S.Content>
      <S.TableRow>
        <TableCell.Component
          size={TableCell.sizes[48]}
          value='cm_name'
          onClick={requestSort}
          direction={getClassNamesFor('cm_name')}
        >
          Campaign
        </TableCell.Component>
        <Buttons.TertiaryNormal
          id='deselectAllAudienceBtn'
          isDisabled={!items?.length}
          onClick={handleDisconnectAll}
        >
          Disconnect All
        </Buttons.TertiaryNormal>
      </S.TableRow>
      <S.ItemsContainer isEmpty={!items?.length}>
        {items.map(({ cm_name, cm_campaignid, status_type_id }, index, array) => {
          const IconToShow = icons[status_type_id] || icons.default;
          return (
            <S.CampaignItem key={cm_campaignid} isLastItem={array.length - 1 === index}>
              <S.IconBlock>
                <IconToShow />
              </S.IconBlock>
              <S.TextBlock>
                <ParagraphWithTooltip text={cm_name} style={{ fontWeight: `500` }} />
                <CopyString label='ID' text={cm_campaignid.toString()} />
              </S.TextBlock>
              <Buttons.TertiaryNormal
                id='deselectAllAudienceBtn'
                onClick={() => handleDeselectCurrent(cm_campaignid)}
                style={{ margin: 'auto 16px auto 0' }}
              >
                Disconnect
              </Buttons.TertiaryNormal>
            </S.CampaignItem>
          );
        })}
      </S.ItemsContainer>
      {useComputed(() => {
        if (notificationModalIsOpen$.value === 'disconnect') {
          return (
            <NotificationModal
              id='disconnect'
              title='Disconnect?'
              iconType={NotificationModal.iconTypes.question}
              isOpen={notificationModalIsOpen$.value}
              cancelBtnType={NotificationModal.btnTypes.SecondaryNormal}
              confirmBtnType={NotificationModal.btnTypes.DestructiveNormal}
              iconSign='?'
              onConfirm={confirmNotificationModal}
              onCancel={closeNotificationModal}
              confirmBtnText='Disconnect'
              cancelBtnText='Cancel'
            >
              Are you sure you want to disconnect the
              <strong> &#34;{campaignToDeleteName.value}&#34;</strong> from your current audience?
            </NotificationModal>
          );
        }
        if (notificationModalIsOpen$.value === 'disconnectAll') {
          return (
            <NotificationModal
              id='disconnectAll'
              title='Disconnect?'
              iconType={NotificationModal.iconTypes.question}
              isOpen={notificationModalIsOpen$.value}
              cancelBtnType={NotificationModal.btnTypes.SecondaryNormal}
              confirmBtnType={NotificationModal.btnTypes.DestructiveNormal}
              iconSign='?'
              onConfirm={confirmNotificationModal}
              onCancel={closeNotificationModal}
              confirmBtnText='Disconnect'
              cancelBtnText='Cancel'
            >
              Are you sure you want to disconnect all campaigns from your current audience?
            </NotificationModal>
          );
        }
      })}
    </S.Content>
  );
};
